var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 125.34120734908136 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l125.34121 0l0 100.0l-125.34121 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l125.34121 0l0 100.0l-125.34121 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m14.982333 95.397026c-16.6212 -24.079727 -12.683464 -56.77249 9.180072 -76.21686c21.863539 -19.444366 54.79245 -19.539013 76.7674 -0.22064972c21.974953 19.318363 26.100555 51.987946 9.61805 76.16283z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m14.982333 95.397026c-16.6212 -24.079727 -12.683464 -56.77249 9.180072 -76.21686c21.863539 -19.444366 54.79245 -19.539013 76.7674 -0.22064972c21.974953 19.318363 26.100555 51.987946 9.61805 76.16283z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m54.376915 62.480797l0 0c0 -4.5797997 3.712658 -8.292461 8.292458 -8.292461l0 0c2.199295 0 4.3085175 0.8736687 5.863655 2.4288063c1.5551376 1.5551376 2.4288025 3.6643562 2.4288025 5.863655l0 0c0 4.579796 -3.7126617 8.292458 -8.292458 8.292458l0 0c-4.5797997 0 -8.292458 -3.7126617 -8.292458 -8.292458z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m54.376915 62.480797l0 0c0 -4.5797997 3.712658 -8.292461 8.292458 -8.292461l0 0c2.199295 0 4.3085175 0.8736687 5.863655 2.4288063c1.5551376 1.5551376 2.4288025 3.6643562 2.4288025 5.863655l0 0c0 4.579796 -3.7126617 8.292458 -8.292458 8.292458l0 0c-4.5797997 0 -8.292458 -3.7126617 -8.292458 -8.292458z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m48.34328 86.74256l36.3048 -69.9297l-32.563076 71.75z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m48.34328 86.74256l36.3048 -69.9297l-32.563076 71.75z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.d51814ca910b01cbdc91061833c910c5.svg";
export { ForwardRef as ReactComponent };